import { render, staticRenderFns } from "./centerVideo.vue?vue&type=template&id=633a5c29&scoped=true&"
import script from "./centerVideo.vue?vue&type=script&lang=js&"
export * from "./centerVideo.vue?vue&type=script&lang=js&"
import style0 from "./centerVideo.vue?vue&type=style&index=0&id=633a5c29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633a5c29",
  null
  
)

export default component.exports